<svg aria-hidden="true" class="passport-offer__check" viewBox="0 0 20 20" fill="none">
  <path
    d="m4 10.5 3.7 3.7L16 6"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2.25"
  />
</svg>

<style>
  .passport-offer__check {
    flex: 0 0 auto;
    width: 1.15rem;
    height: 1.15rem;
    margin-top: 0.05rem;
    color: var(--passport-accent);
  }
</style>
